import React, { Suspense, useEffect } from 'react';
import Card from '@/components/card';
import { Tabs, TabsProps } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import OrderInfo from './components';
import BreadcrumbComponent from '@/components/breadcrumb';
import { useQuery } from '@tanstack/react-query';
import { getOrder } from '@/adapters/manual-order';
import { IOrder } from '@/interfaces/order';
import { useMedia } from '@/contexts/MediaContext';

const OrderManualDetail = () => {
  const { setMedia } = useMedia();
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: order, refetch } = useQuery<IOrder, Error>({
    queryKey: ['get-order-manual', id],
    queryFn: async () => await getOrder(Number(id)),
  });

  const items: TabsProps['items'] = [
    {
      key: 'product-info',
      label: 'ข้อมูลออเดอร์',
      children: (
        <Suspense>
          {order && (
            <OrderInfo
              data={order}
              onRefresh={() => refetch()}
              isManual={true}
            />
          )}
        </Suspense>
      ),
    },
  ];

  useEffect(() => {
    return () => {
      setMedia(undefined);
    };
  }, []);

  return (
    <Card>
      <BreadcrumbComponent
        items={[
          {
            title: (
              <div
                className="cursor-pointer"
                onClick={() => navigate(`/order-free-form`)}
              >
                ออเดอร์
              </div>
            ),
          },
          {
            title: (
              <div className="flex flex-row gap-2 items-center">
                {order?.code}
                {order?.cndnId && (
                  <div
                    className="text-red-500 underline cursor-pointer underline-offset-2"
                    onClick={() =>
                      window.open(`/cndn-note/${order.cndnId}`, '_blank')
                    }
                  >
                    ({order.cndnCode})
                  </div>
                )}
              </div>
            ),
          },
        ]}
      />
      <div className="flex flex-col gap-4">
        <Tabs
          defaultActiveKey="1"
          items={items}
          className="w-full"
          rootClassName="font-medium"
        />
      </div>
    </Card>
  );
};

export default OrderManualDetail;
